import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { loadState, saveState } from '../utils/localStorage';
import { clearHistory } from '../utils/history';
import { decodeStateAndHistory } from '../utils/importExport';
import LanguageSettings from '../components/settings/LanguageSettings';
import DataManagement from '../components/settings/DataManagement';
import LevelSettings from '../components/settings/LevelSettings';

const SettingsView = () => {
  const { t } = useTranslation();
  const [state, setState] = useState(() => {
    const loaded = loadState();
    return loaded && typeof loaded === 'object'
      ? { version: 1, totalPushups: 0, userProgress: { currentLevelIndex: 0, currentSetIndex: 0 }, ...loaded, settings: { soundEnabled: true, ...(loaded.settings || {}) } }
      : { version: 1, totalPushups: 0, userProgress: { currentLevelIndex: 0, currentSetIndex: 0 }, settings: { soundEnabled: true } };
  });

  const currentLevelIndex = state.userProgress?.currentLevelIndex || 0;

  const handleLevelChange = (newIndex) => {
    const newState = {
      ...state,
      userProgress: {
        ...(state.userProgress || {}),
        currentLevelIndex: newIndex,
        currentSetIndex: 0
      }
    };
    setState(newState);
    saveState(newState);
  };

  function toggleSound() {
    const newState = { ...state, settings: { ...state.settings, soundEnabled: !state.settings.soundEnabled } };
    setState(newState);
    saveState(newState);
  }

  // Import from URL hash
  React.useEffect(() => {
    if (window.location.hash.startsWith('#import=')) {
      try {
        const base64 = decodeURIComponent(window.location.hash.replace('#import=', ''));
        const { state: imported, history } = decodeStateAndHistory(base64);
        if (window.confirm('Import detected in URL. Overwrite your progress?')) {
          saveState(imported);
          setState(imported);
          clearHistory();
          localStorage.setItem('pushupProHistory', JSON.stringify(history));
          window.location.hash = '';
          window.location.reload();
        }
      } catch {}
    }
  }, []);

  return (
    <div style={{ paddingBottom: 60, minHeight: '100vh', background: '#fbeff3', fontFamily: 'Inter, Roboto, Segoe UI, Arial, sans-serif', color: '#333' }}>
      <h2 className="pretty-title">{t('settings')}</h2>

      <LanguageSettings
        soundEnabled={!!(state.settings && state.settings.soundEnabled)}
        onToggleSound={toggleSound}
      />

      <DataManagement state={state} />

      <LevelSettings
        currentLevelIndex={currentLevelIndex}
        onLevelChange={handleLevelChange}
      />

      <div style={{ marginTop: 32, color: '#888', fontSize: 14, textAlign: 'center' }}>
        {t('data_security_notice')}
      </div>
    </div>
  );
};

export default SettingsView;
